export const WindowLayer = Object.freeze({
  CONTENT: 0,
  NAVIGATION: 1000,
  CHROME: 1100,
  POPUP: 1200,
  DIALOG: 1300,
  NOTIFICATION: 1400,
  TOOLTIP: 1500
});

export function resolveWindowLayer(layer) {
  if (typeof layer === "number" && Number.isFinite(layer)) {
    return layer;
  }

  if (typeof layer === "string") {
    const value = WindowLayer[layer.trim().toUpperCase()];

    if (Number.isFinite(value)) {
      return value;
    }
  }

  throw new Error("Unknown window layer: " + String(layer));
}
